__turbopack_context__.v({
  "className": "noto_sans_telugu_2befd167-module__hUmIuq__className",
});
